import React, { useEffect, useState } from 'react';
import menuItems from './../../Utilites/AppData.json';
import logo1 from '../../components/Image/logo2.jpg';
import { GiRoyalLove } from 'react-icons/gi';
import { GiShoppingCart } from 'react-icons/gi';
import { Link } from 'react-router-dom';
import images2 from '../../components/Image/images2.png'
const Navbar = () => {

    const [theme, setTheme] = useState(localStorage.getItem('theme') ? localStorage.getItem("theme") : "light")
    const handelToggle = (e) => {

        if (e.target.checked) {
            setTheme("dark");
        }
        else {
            setTheme("light");
        }
    }
    useEffect(() => {
        localStorage.setItem("theme", theme);
        const localTheme = localStorage.getItem("theme");
        document.querySelector('html').setAttribute("data-theme", localTheme);

    }, [theme]);


    return (
        <>


            <nav className=' bg-gray-100 justify-between hidden lg:flex '>

                <div className="avatar">
                    <div className="w-10 ml-2 rounded-full">
                        <img src={logo1} alt="" />
                    </div>
                </div>
                <ul className="flex flex-row font-medium rounded-lg  ml-3 ">
                    <li>
                        <a href="..." className="block py-2 pl-3 pr-4 hover:bg-slate-300 btn-sm rounded-lg ">NikeRefurbished <samp> |</samp></a>
                    </li>
                    <li>
                        <a href="..." className="block py-2 pl-3 pr-4 hover:bg-slate-300 btn-sm rounded-lg">Find a Store <samp> |</samp></a>
                    </li>
                    <li>
                        <a href="..." className="block py-2 pl-3 pr-4 hover:bg-slate-300 btn-sm rounded-lg">  Help  <samp> |</samp></a>
                    </li>
                    <li>
                        <a href="..." className="block py-2 pl-3 pr-4 hover:bg-slate-300 btn-sm rounded-lg">Join Us <samp> |</samp></a>
                    </li>
                    <li>
                        <a href="..." className="block py-2 pl-3 pr-4 hover:bg-slate-300 btn-sm rounded-lg">Sing In </a>
                    </li>
                </ul>
            </nav>


            <div className="navbar ">

                <div className="navbar-start">
                    <div className="dropdown">
                        <label tabIndex={0} className="btn btn-ghost lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                        </label>
                        <ul tabIndex={0} className="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52">
                            <li><Link to='/'>Home</Link></li>
                            <li><a href='...'>NEW ARRIVALS</a></li>
                            <li><a href="....">GIFTS</a></li>
                            <li><a href="....">COUTURE</a></li>
                            <li>
                                <a href="..." className="block py-2 pl-3 pr-4 ">Home</a>
                            </li>
                            <li>
                                <a href="..." className="block py-2 pl-3 pr-4 ">Services</a>
                            </li>
                            <li>
                                <a href="..." className="block py-2 pl-3 pr-4 ">Pricing</a>
                            </li>
                            <li>
                                <a href="..." className="block py-2 pl-3 pr-4">Contact</a>
                            </li>

                            <ul className="space-x-2">
                                {menuItems.map((menuItem, index) => (
                                    <li key={index} className="relative group">
                                        <a href="..." className="">
                                            {menuItem.title}
                                        </a>
                                        <div className="absolute hidden mt-8 bg-white text-black group-hover:block w-96">
                                            <div className="space-y-2">

                                                <ul>
                                                    {
                                                        menuItem?.subItems?.map((v, index) => <div key={index}>
                                                            <h3 className="text-sm font-bold text-center mb-4">{v.catagoties}</h3>
                                                            <div className='grid lg:grid-cols-3 sm:grid-cols-1 gap-8'>
                                                                {v.items.map((v, index) => <li key={index}>
                                                                    <a href="..." className="hover:text-gray-600">
                                                                        {v}
                                                                    </a>
                                                                </li>)}
                                                            </div>
                                                        </div>)
                                                    }


                                                </ul>



                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </ul>


                        </ul>


                    </div>
                    <div className="w-16 ml-2 rounded-full">
                        <img src={images2} alt="" />
                    </div>
                    {/* <a className="btn btn-ghost btn-sm normal-case text-xl" href='...'></a> */}
                </div>
                <div className="navbar-center hidden lg:flex">
                    <ul className="menu menu-horizontal px-1">
                        <li><Link to='/'>Home</Link></li>
                        <li><a href='...'>NEW ARRIVALS</a></li>
                        <li><a href="....">GIFTS</a></li>
                        <li><a href="....">COUTURE</a></li>
                        <ul className="flex space-x-2">
                            {menuItems.map((menuItem, index) => (
                                <li key={index} className="relative group">
                                    <a href="..." className="">
                                        {menuItem.title}
                                    </a>
                                    <div className="absolute hidden mt-8 bg-white text-black group-hover:block w-96">
                                        <div className="space-y-2">

                                            <ul>
                                                {
                                                    menuItem?.subItems?.map((v, index) => <div key={index}>
                                                        <h3 className="text-sm font-bold text-center mb-4">{v.catagoties}</h3>
                                                        <div className='grid lg:grid-cols-3 sm:grid-cols-1 gap-8'>
                                                            {v.items.map((v, index) => <li key={index}>
                                                                <a href="..." className="hover:text-gray-600">
                                                                    {v}
                                                                </a>
                                                            </li>)}
                                                        </div>
                                                    </div>)
                                                }


                                            </ul>



                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    </ul>
                </div>
                <div className="navbar-end">
                    <div className='hidden lg:flex'>
                        <input type="text" placeholder="Type here" className="input input-bordered rounded-full w-72 max-w-xs mr-3"></input>
                    </div>
                    <a href='...' className="btn btn-outline bg-red-600 btn-sm m-3"><GiRoyalLove className='text-xl' /></a>

                    <Link className="btn btn-outline btn-sm m-3" to="/add_to_card"><GiShoppingCart className='text-xl' /></Link>
                    <label className="swap swap-rotate">

                        {/* this hidden checkbox controls the state */}

                        <input type="checkbox" onChange={handelToggle} />

                        {/* sun icon */}
                        <svg className="swap-on fill-current w-10 h-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M5.64,17l-.71.71a1,1,0,0,0,0,1.41,1,1,0,0,0,1.41,0l.71-.71A1,1,0,0,0,5.64,17ZM5,12a1,1,0,0,0-1-1H3a1,1,0,0,0,0,2H4A1,1,0,0,0,5,12Zm7-7a1,1,0,0,0,1-1V3a1,1,0,0,0-2,0V4A1,1,0,0,0,12,5ZM5.64,7.05a1,1,0,0,0,.7.29,1,1,0,0,0,.71-.29,1,1,0,0,0,0-1.41l-.71-.71A1,1,0,0,0,4.93,6.34Zm12,.29a1,1,0,0,0,.7-.29l.71-.71a1,1,0,1,0-1.41-1.41L17,5.64a1,1,0,0,0,0,1.41A1,1,0,0,0,17.66,7.34ZM21,11H20a1,1,0,0,0,0,2h1a1,1,0,0,0,0-2Zm-9,8a1,1,0,0,0-1,1v1a1,1,0,0,0,2,0V20A1,1,0,0,0,12,19ZM18.36,17A1,1,0,0,0,17,18.36l.71.71a1,1,0,0,0,1.41,0,1,1,0,0,0,0-1.41ZM12,6.5A5.5,5.5,0,1,0,17.5,12,5.51,5.51,0,0,0,12,6.5Zm0,9A3.5,3.5,0,1,1,15.5,12,3.5,3.5,0,0,1,12,15.5Z" /></svg>

                        {/* moon icon */}
                        <svg className="swap-off fill-current w-10 h-10" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path d="M21.64,13a1,1,0,0,0-1.05-.14,8.05,8.05,0,0,1-3.37.73A8.15,8.15,0,0,1,9.08,5.49a8.59,8.59,0,0,1,.25-2A1,1,0,0,0,8,2.36,10.14,10.14,0,1,0,22,14.05,1,1,0,0,0,21.64,13Zm-9.5,6.69A8.14,8.14,0,0,1,7.08,5.22v.27A10.15,10.15,0,0,0,17.22,15.63a9.79,9.79,0,0,0,2.1-.22A8.11,8.11,0,0,1,12.14,19.73Z" /></svg>

                    </label>

                </div>
            </div>


        </>
    );
};

export default Navbar;